// extracted by mini-css-extract-plugin
export default {"modalBody":"confirm-delete-modal_modalBody__oas2H","name":"confirm-delete-modal_name__6lBsu","button":"confirm-delete-modal_button__uUlBP"};